// The Files card's own files in the Record board's words (S14): the document types, the lines in
// the Upload a file popup, the delete confirm and the toasts. Pure, so the card and the tests read
// the same lines.
import type { FetchView, FileType } from '../auth/api';

/** "Document type", in this order. */
export const fileTypeChoices: { type: FileType; label: string }[] = [
  { type: 'dec_page', label: 'Dec page' },
  { type: 'id_cards', label: 'ID cards' },
  { type: 'change', label: 'Change' },
  { type: 'other', label: 'Other' },
];

export const fileTypeLabel = (type: FileType) =>
  fileTypeChoices.find((c) => c.type === type)?.label ?? 'Other';

export const dropTitle = 'Drag a PDF here';
export const dropLine = 'PDF up to 20 MB. One file.';
export const decPageNote =
  'This adds a file only. To change the dec page the steps use, use Replace in step 1.';
export const filesFootnote =
  'Everyone who can open this renewal sees the file. Nothing is written to AMS360.';

/** Upload PDF on the card works only for someone who works the record, and not once it is closed. */
export const canAddFiles = (view: FetchView | null) => !!view && view.canWork && !view.closed;

/** The popup's primary is on once there is a file and a type. */
export const canSendFile = (file: unknown, type: FileType | null) => !!file && type !== null;

export const uploadedFileText = (name: string) => `Uploaded ${name}.`;
export const alreadyThereText = 'This file was already on the record.';

export const deleteTitle = (name: string) => `Delete ${name}?`;
export const deleteLine = 'It is removed from this renewal. The portal log keeps the file name.';
export const deletedText = (name: string) => `Deleted ${name}.`;
export const restoredText = (name: string) => `Undone. ${name} is back on the record.`;
export const cannotUndoText = 'Could not undo. Reload the page.';
